export default "/images/vendor/flag-icon-css/flags/1x1/md.svg?efdfab01385b30e739862fd2fc165f48";